// client js begin
if (typeof document !== 'undefined' && !document.getElementById('svg_icon_wechat_xs')) {
  var accountTypeIconSvg = require("./accountTypeIcon.svg.js");

  document.head.insertAdjacentHTML('beforeend', accountTypeIconSvg);
} // client js end


export default {
  name: 'VftAccountType',
  props: {
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: true
    },
    useWhiteBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    accountType: function accountType() {
      if (this.userInfo && typeof this.userInfo.type !== 'undefined') {
        var type = this.userInfo.type;

        if (type === 'wx' || type === 'qq') {
          return type;
        }

        return this.userInfo.type === 1 ? 'wx' : 'qq';
      }

      return '';
    }
  }
};